(function () {
    'use strict';

    angular
        .module('app')
        .controller('BadgesController', BadgesController);

    BadgesController.$inject = ['$state',];

    function BadgesController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'badges') {
                $state.go('badges.list');
            }
        }
    }
})();